/**
 * Best-effort client → server consent ledger write (GDPR plan P1-4). Records
 * each grant/withdraw for accountability (GDPR Art. 7(1)). Fire-and-forget:
 * never blocks the UI, never throws, and silently no-ops if the endpoint is
 * absent. The endpoint is a PUBLIC Strapi route (consent can happen pre-login
 * on marketing pages) — see server/src/api/consent-event.
 */
import { CONSENT_VERSION } from './consentConfig';

export function recordConsent(record, source) {
  if (typeof window === 'undefined') return;
  try {
    // NEXT_PUBLIC_DB_URL is the app's API base (see util/DB_URL.js);
    // NEXT_PUBLIC_API_URL is kept only as a fallback for deployments that
    // define it.
    const apiUrl = process.env.NEXT_PUBLIC_DB_URL || process.env.NEXT_PUBLIC_API_URL;
    if (!apiUrl) return;
    const payload = {
      version: record?.version || CONSENT_VERSION,
      categories: record?.categories || {},
      source: source || 'unknown',
      surface: 'dashboard',
      path: window.location?.pathname,
      url: window.location?.origin,
    };
    // Strapi REST create expects a `{ data }` envelope. keepalive lets the
    // write survive a page-unload navigation. credentials omitted — the ledger
    // is intentionally pseudonymous (no auth required, no cookies sent).
    fetch(`${apiUrl}/api/consent-events`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ data: payload }),
      keepalive: true,
      credentials: 'omit',
    }).catch(() => {});
  } catch {
    // The ledger must never break the user's flow.
  }
}
